import React, { FC, memo } from 'react';
import cls from './DaysModeCharter.module.css';
import classNames from 'classnames';
import { CharterItem } from '../../../../../../UI/CharterItem/CharterItem';
import moment from 'moment/moment';

export const DayItemCharter = memo(({ month, charter, isPlanFact, currentDay, currentMonths }) => {
    const nowDate = moment().format('DD.MM.YYYY');
    const charterStartDate = moment(charter.planned.start_date).format('DD.MM.YYYY');

    return (
        <>
            {month.days.map((day) => (
                <div
                    key={day.day}
                    className={classNames(cls.day, {
                        [cls.factWrapper]: isPlanFact,
                        [cls.weekend]: day.isWeekend,
                        [cls.nowDate]: day.date === nowDate,
                    })}
                >
                    {day.date === charterStartDate && (
                        <CharterItem isPlanFact={isPlanFact} charter={charter} />
                        // <StageItem isPlanFact={isPlanFact} stage={stage} id={`${stage.guid}`} />
                    )}
                </div>
            ))}
        </>
    );
});
